import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular-ivy';

import { hmrBootstrap } from './hmr';
import { BrowserTracing, Replay } from '@sentry/angular-ivy';

if (environment.production) {
  enableProdMode();
}

  Sentry.init({
    dsn: "https://85bcfd4946aee79a1ba64f8e1e1264e8@o4510000915349504.ingest.de.sentry.io/4510022899990608",
    sendDefaultPii: true,
    enabled: window.location.hostname !== 'localhost' && window.location.hostname !== 'https://kdoteszt.frederik2.hu',

    integrations: [
      new BrowserTracing({
        tracePropagationTargets: ['localhost', /^https:\/\/your\.api/],
      }),
      new Replay({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // tracesSampleRate: 1.0,           // tune lower in prod
    // replaysSessionSampleRate: 0.1,
    // replaysOnErrorSampleRate: 1.0,
    // tunnel: '/sentry-tunnel',     // optional
  });

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
  if (module['hot']) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --hmr flag for ng serve?');
  }
} else {
  bootstrap().catch(err => console.log(err));
}
